import NotifyMessage    from "../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyRepository from "../../../domain/fundamentals/message/notify/NotifyRepository";
import NotifyType       from "../../../domain/fundamentals/message/notify/NotifyType";
import {
  notifyDeleteFailure,
  notifyDeleteSuccess,
  notifyFetchFailure,
  notifyMailSendSuccess,
  notifyOptionalMessage,
  notifySaveFailure,
  notifySaveSuccess
}                       from "../../redux/notify/NotifyAction";

class NotifyDataSource implements NotifyRepository {
  readonly dispatch;

  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  saveFailure(): void {
    this.dispatch(notifySaveFailure());
  }

  saveSuccess(): void {
    this.dispatch(notifySaveSuccess());
  }

  deleteSuccess(): void {
    this.dispatch(notifyDeleteSuccess());
  }

  deleteFailure(): void {
    this.dispatch(notifyDeleteFailure());
  }

  fetchFailure(): void {
    this.dispatch(notifyFetchFailure());
  }

  mailSendSuccess(): void {
    this.dispatch(notifyMailSendSuccess());
  }

  optionalMessage(notifyType: NotifyType, notifyMessage: NotifyMessage): void {
    this.dispatch(notifyOptionalMessage(notifyType, notifyMessage));
  }

}

export default NotifyDataSource;